export default __webpack_public_path__ + "static/media/meals.4d9de94f.svg";